import { useMutation } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";
import { clearCoachMetadata } from "@/client/libs/coach-metadata";
import { queryClient } from "@/client/libs/query-client";
import { useAuthStore } from "@/client/stores/auth";

export const logout = () => axios.post("/auth/logout");

export const useLogout = () => {
  const setUser = useAuthStore((state) => state.setUser);

  const clearClientAuthState = () => {
    clearCoachMetadata();
    setUser(null);
    queryClient.setQueryData(["user"], null);
  };

  const {
    error,
    isPending: loading,
    mutateAsync: logoutFn,
  } = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      clearClientAuthState();
    },
    onError: () => {
      clearClientAuthState();
    },
  });

  return { logout: logoutFn, loading, error };
};
